module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Used Space")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("49/50\n                  "), _c('small', [_vm._v("GB")])])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons text-danger"
  }, [_vm._v("warning")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#pablo"
    }
  }, [_vm._v("Get More Space...")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("store")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Revenue")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("$34,245")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("date_range")]), _vm._v(" Last 24 Hours\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("info_outline")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Fixed Issues")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("75")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_offer")]), _vm._v(" Tracked from Github\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "blue"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Followers")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("+245")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("update")]), _vm._v(" Just Updated\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "id": "dailySales",
      "chart-data": _vm.dailySalesChart.data,
      "chart-options": _vm.dailySalesChart.options
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Daily Sales")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up"
  }), _vm._v(" 55%  ")]), _vm._v("\n                  increase in today sales.")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" updated 4 minutes ago\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "color": "orange",
      "chart-type": "Bar",
      "id": "emailSubscriptions",
      "chart-data": _vm.emailSubscriptionsChart.data,
      "chart-options": _vm.emailSubscriptionsChart.options,
      "responsive-options": _vm.emailSubscriptionsChart.responsiveOptions
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Email Subscriptions")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Last Campaign Performance")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" campaign sent 2 days ago\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "color": "red",
      "id": "completedTasks",
      "chart-data": _vm.completedTasksChart.data,
      "chart-options": _vm.completedTasksChart.options
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Completed Tasks")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Last Campaign Performance")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" campaign sent 2 days ago\n          ")])])], 1)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "orange"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Employees Stats")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("New employees on 15th September, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', {
    staticClass: "text-warning"
  }, [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', [_vm._v("Country")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Dakota Rice")]), _vm._v(" "), _c('td', [_vm._v("$36,738")]), _vm._v(" "), _c('td', [_vm._v("Niger")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("Minerva Hooper")]), _vm._v(" "), _c('td', [_vm._v("$23,789")]), _vm._v(" "), _c('td', [_vm._v("Curaçao")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("Sage Rodriguez")]), _vm._v(" "), _c('td', [_vm._v("$56,142")]), _vm._v(" "), _c('td', [_vm._v("Netherlands")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("Philip Chaney")]), _vm._v(" "), _c('td', [_vm._v("$38,735")]), _vm._v(" "), _c('td', [_vm._v("Korea, South")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bc30a86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Dashboard.vue
// module id = 166
// module chunks = 2